/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/formaPagamento/formaPagamento.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import EditFormasPagamento from './formasPagamento.template';
import { SelectChangeEvent } from '@mui/material';

const api = useApi();

export default function FormasPagamento() {
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);
  const [formaPagamento, setFormaPagamento] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [neg, setNeg] = useState();
  const [edit, setEdit] = useState<boolean>(false);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>([]);

  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  useEffect(() => {
    setLoading(true);
    api
      .get('/pagamento' + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        if (response.results.length < 1) {
          setLoadingMensagem('Desculpe-me, mas não há FORMA DE PAGAMENTO cadastradas atualmente.');
          setLoadingBtn('OK');
        } else setLoading(false);

        setFormaPagamento(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }, [page, like]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/pagamento/');
    setItemExclude(row);
    setOpen(true);
  };

  const handleAtualizar = (row: any) => {
    setNeg(row);
    setEdit(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleAtualizar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(formaPagamento),
  };

  const handleFilterColumnsChange = (event: SelectChangeEvent<typeof selectedFilterColumns>) => {
    setSelectedFilterColumns(event.target.value as string[]);
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path}
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
          showFilterButton={false}
        />
      )}
      {edit && <EditFormasPagamento dado={neg} setEdit={() => setEdit(false)} />}
    </>
  );
}
